(function () {
  var STORAGE_KEY = "dayrhythm_gosub_selection";
  var PARAM_KEY = "dr_selection";
  var MAX_AGE_MS = 30 * 60 * 1000;
  var MAX_ATTEMPTS = 50;
  var RETRY_DELAY_MS = 250;

  var readStorage = function () {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  };

  var clearStorage = function () {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      return;
    }
  };

  var parsePayload = function (raw) {
    if (!raw) return null;

    try {
      var payload = JSON.parse(raw);
      if (!payload || !Array.isArray(payload.items)) return null;
      if (payload.createdAt && Date.now() - payload.createdAt > MAX_AGE_MS) return null;
      return payload;
    } catch (error) {
      return null;
    }
  };

  var readPayload = function () {
    var fromUrl = null;

    try {
      fromUrl = new URLSearchParams(window.location.search).get(PARAM_KEY);
    } catch (error) {
      fromUrl = null;
    }

    return parsePayload(fromUrl) || parsePayload(readStorage());
  };

  var normalizeTitle = function (value) {
    return String(value || "")
      .normalize("NFKC")
      .toLowerCase()
      .replace(/(あさ|ひる|よる)リズム/g, "")
      .replace(/[×✕✖x・|｜、,／\/\s　()（）\[\]【】「」『』_-]/g, "");
  };

  var getBoxTarget = function () {
    var titleEl = document.querySelector(".gosub-box__title");
    if (!titleEl) return null;

    var match = titleEl.textContent.match(/(\d+)\s*袋/);
    return match ? parseInt(match[1], 10) : null;
  };

  var getProductTitle = function (product) {
    var titleEl = product.querySelector(".gosub-box__product-title");
    return titleEl ? titleEl.textContent.trim() : product.getAttribute("data-search-content") || "";
  };

  var getProductQtyInput = function (product) {
    return product.querySelector(".gosub-box__product-quantity-input");
  };

  var getProductQty = function (product) {
    var input = getProductQtyInput(product);
    return input ? parseInt(input.textContent, 10) || 0 : 0;
  };

  var getQuantityValue = function (input) {
    if (!input) return 0;

    var value = input.value !== undefined ? input.value : input.textContent;
    return parseInt(value, 10) || 0;
  };

  var setQuantityValue = function (input, value) {
    if (!input) return;

    if (input.value !== undefined) {
      input.value = String(value);
      input.setAttribute("value", String(value));
    } else {
      input.textContent = String(value);
    }

    input.setAttribute("aria-readonly", "true");
    input.setAttribute("data-dayrhythm-locked", "true");
  };

  var getBoxQuantityButton = function (boxQuantity, action) {
    var buttons = boxQuantity.querySelectorAll(".gosub-box__box-quantity-btn");
    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      var actionValue = [
        button.getAttribute("data-button-box-action"),
        button.getAttribute("data-button-product-action"),
        button.getAttribute("data-button-action"),
        button.textContent
      ].join(" ").toLowerCase();

      if (action === "minus" && (actionValue.indexOf("minus") !== -1 || actionValue.indexOf("decrease") !== -1 || button.textContent.trim() === "-")) {
        return button;
      }

      if (action === "add" && (actionValue.indexOf("add") !== -1 || actionValue.indexOf("plus") !== -1 || actionValue.indexOf("increase") !== -1 || button.textContent.trim() === "+")) {
        return button;
      }
    }

    return null;
  };

  var lockBoxQuantity = function () {
    var boxQuantity = document.querySelector(".gosub-box__box-quantity");
    if (!boxQuantity) return false;

    var input = boxQuantity.querySelector(".gosub-box__box-quantity-input");
    if (!input) return false;

    var minusButton = getBoxQuantityButton(boxQuantity, "minus");
    var attempts = 0;

    while (getQuantityValue(input) > 1 && minusButton && !minusButton.disabled && attempts < 20) {
      minusButton.click();
      attempts += 1;
    }

    setQuantityValue(input, 1);
    boxQuantity.classList.add("is-dayrhythm-locked");

    var buttons = boxQuantity.querySelectorAll(".gosub-box__box-quantity-btn");
    for (var i = 0; i < buttons.length; i += 1) {
      buttons[i].disabled = true;
      buttons[i].setAttribute("aria-disabled", "true");
      buttons[i].setAttribute("tabindex", "-1");
      buttons[i].setAttribute("data-dayrhythm-locked", "true");
    }

    return true;
  };

  var findProduct = function (title) {
    var wanted = normalizeTitle(title);
    if (!wanted) return null;

    var products = document.querySelectorAll(".gosub-box__product");
    var partialMatches = [];

    for (var i = 0; i < products.length; i += 1) {
      var found = normalizeTitle(getProductTitle(products[i]));
      if (found === wanted) {
        return products[i];
      }

      if (found.indexOf(wanted) !== -1 || wanted.indexOf(found) !== -1) {
        partialMatches.push(products[i]);
      }
    }

    return partialMatches.length === 1 ? partialMatches[0] : null;
  };

  var clickQuantityButton = function (product, action) {
    var input = getProductQtyInput(product);
    if (!input) return false;

    var productId = input.getAttribute("data-product-id") || input.id;
    if (!productId) return false;

    var selector = '.gosub-box__product-quantity-btn[data-button-product-id="' + productId + '"][data-button-product-action="' + action + '"]';
    var button = product.querySelector(selector);
    if (!button || button.disabled) return false;

    button.click();
    return true;
  };

  var clearQuantities = function () {
    var products = document.querySelectorAll(".gosub-box__product");
    for (var i = 0; i < products.length; i += 1) {
      var qty = getProductQty(products[i]);
      for (var count = 0; count < qty; count += 1) {
        clickQuantityButton(products[i], "minus");
      }
    }
  };

  var applyPayload = function (payload) {
    var wrapper = document.getElementById("gosub-box__wrapper");
    if (!wrapper) return false;

    var boxTarget = getBoxTarget();
    if (payload.target && boxTarget && payload.target !== boxTarget) return true;

    var matches = [];
    for (var i = 0; i < payload.items.length; i += 1) {
      var item = payload.items[i];
      var quantity = parseInt(item.quantity, 10) || 0;
      if (quantity <= 0) continue;

      var product = findProduct(item.title);
      if (!product) return false;

      matches.push({
        product: product,
        quantity: quantity
      });
    }

    if (!matches.length) return true;

    clearQuantities();

    for (var matchIndex = 0; matchIndex < matches.length; matchIndex += 1) {
      for (var qtyIndex = 0; qtyIndex < matches[matchIndex].quantity; qtyIndex += 1) {
        clickQuantityButton(matches[matchIndex].product, "add");
      }
    }

    for (var verifyIndex = 0; verifyIndex < matches.length; verifyIndex += 1) {
      if (getProductQty(matches[verifyIndex].product) !== matches[verifyIndex].quantity) {
        return false;
      }
    }

    clearStorage();
    return true;
  };

  document.addEventListener("click", function (event) {
    if (event.target.closest(".gosub-box__box-quantity-btn, .gosub-box__submit-button")) {
      lockBoxQuantity();
    }
  }, true);

  var payload = readPayload();
  var hasPayload = payload && payload.items.length;

  var attempts = 0;
  var done = !hasPayload;

  var run = function () {
    lockBoxQuantity();
    if (done) return;

    attempts += 1;
    done = applyPayload(payload);

    if (!done && attempts < MAX_ATTEMPTS) {
      window.setTimeout(run, RETRY_DELAY_MS);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  window.addEventListener("load", function () {
    window.setTimeout(run, RETRY_DELAY_MS);
  });

  if ("MutationObserver" in window) {
    var observerDelay;
    var observer = new MutationObserver(function () {
      window.clearTimeout(observerDelay);
      observerDelay = window.setTimeout(run, RETRY_DELAY_MS);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
